/**
 * Horizon overrides for Shopify.actions:
 * - updateCart: emit events from the cart drawer scope and let Spot's cart
 *   preserve configured-build integrity for existing-line quantity changes.
 * - openCart: open the cart drawer (fall back to /cart when absent).
 *
 * Spot (#834): see SPOT.md §1.
 */

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => document.querySelector('theme-drawer#cart-drawer') ?? document,
    async handler(defaultHandler, payload, options) {
      /**
       * @type {HTMLElement & {
       *   handleStandardUpdateCart?: (
       *     defaultHandler: () => Promise<unknown>,
       *     payload: Record<string, unknown>,
       *     options?: Record<string, unknown>,
       *   ) => Promise<unknown>
       * } | null}
       */
      const cartItems = document.querySelector('spot-cart-items');

      if (!cartItems?.handleStandardUpdateCart) return defaultHandler();
      const result = await cartItems.handleStandardUpdateCart(defaultHandler, payload, options);
      const lines = result?.cart?.lines;

      // The public Standard Actions type says `cart.lines` is an array, but the
      // current runtime applies its own final normalization after a configured
      // handler returns and reads `cart.lines.nodes`. Hand Shopify that private
      // wire shape only at this boundary; otherwise it replaces the array with
      // `undefined` and the original CartLinesUpdateEvent promise rejects.
      if (!Array.isArray(lines)) return result;

      return {
        ...result,
        cart: {
          ...result.cart,
          lines: { nodes: lines },
        },
      };
    },
  });

  actions.openCart.configure({
    async handler() {
      /** @type {HTMLElement & {open?: () => void} | null} */
      const drawer = document.querySelector('theme-drawer#cart-drawer');

      if (drawer?.open) {
        drawer.open();
      } else {
        window.location.href = Theme.routes.cart_url || '/cart';
      }
    },
  });
}

// Run immediately if the standard-actions bundle has already attached
// `Shopify.actions`; otherwise wait for DOMContentLoaded, which fires after
// all module scripts have executed regardless of document order.
if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
